import React from 'react';
import PDFViewer from 'components/PDFViewer';
import './catalogo-pdf.css';

const PDF_URL = `${process.env.PUBLIC_URL}/pdfs/Puntos-naranjas-Premios.pdf`;

export default function CatalogoPDF() {
  return (
    <div className="catalogo-pdf-page">
      <PDFViewer
        fileUrl={PDF_URL}
        fileName="Puntos-naranjas-Premios.pdf"
      />
    </div>
  );
}
